import logoImg from './logo.png';

export var BRAND  = "#0F2C70";
export var iStyle = {width:"100%",border:"1px solid #dde3f0",borderRadius:8,padding:"9px 12px",fontSize:13,boxSizing:"border-box",background:"#f7f9fc",outline:"none",color:"#1e293b"};

export function KofidesLogo(p) {
  var size = p.size || 64;
  return (
    <div style={{width:size,height:size,borderRadius:"50%",flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center",overflow:"hidden"}}>
      <img src={logoImg} alt="Kofides" style={{width:"100%",height:"100%",objectFit:"contain"}}/>
    </div>
  );
}

export function Lbl(p)  { return <label style={{fontSize:11,color:"#64748b",display:"block",marginBottom:5,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.5px"}}>{p.c}</label>; }
export function Inp(p)  { var sx=p.sx||{}; var r=Object.assign({},p); delete r.sx; return <input style={Object.assign({},iStyle,sx)} {...r}/>; }
export function Slct(p) { var sx=p.sx||{}; var r=Object.assign({},p); delete r.sx; return <select style={Object.assign({},iStyle,sx)} {...r}>{p.children}</select>; }
export function Btn(p)  { var bg=p.bg||BRAND; var sx=p.sx||{}; var r=Object.assign({},p); delete r.bg; delete r.sx; return <button style={Object.assign({},{padding:"10px 18px",borderRadius:9,border:"none",background:bg,color:"#fff",fontWeight:600,fontSize:13,cursor:"pointer"},sx)} {...r}>{p.children}</button>; }
export function Card(p) { var sx=p.sx||{}; return <div style={Object.assign({},{background:"#fff",borderRadius:14,padding:"20px 22px",boxShadow:"0 1px 4px rgba(15,44,112,0.08)"},sx)}>{p.children}</div>; }
export function KPI(p)  {
  var color=p.color||BRAND; var hasSub=p.sub?true:false;
  return (
    <div style={{background:p.bg,border:"1px solid "+p.border,borderRadius:12,padding:"16px 20px"}}>
      <p style={{margin:0,fontSize:11,color:"#64748b",fontWeight:600,textTransform:"uppercase",letterSpacing:"0.5px"}}>{p.label}</p>
      <p style={{fontSize:22,fontWeight:800,color:color,margin:"6px 0 0"}}>{p.value}</p>
      {hasSub?<p style={{fontSize:11,color:p.good?"#16a34a":"#dc2626",margin:"4px 0 0",fontWeight:600}}>{p.sub}</p>:null}
    </div>
  );
}
export function SH(p) { return <div style={{borderBottom:"2px solid "+BRAND+"22",paddingBottom:5,marginBottom:14,marginTop:22}}><p style={{margin:0,fontSize:11,fontWeight:800,color:BRAND,textTransform:"uppercase",letterSpacing:"0.6px"}}>{p.t}</p></div>; }
export function NavBtn(p) {
  return <button onClick={p.onClick} disabled={p.disabled} style={{padding:"4px 9px",borderRadius:6,border:"1px solid #dde3f0",fontSize:12,background:"#fff",cursor:p.disabled?"default":"pointer",color:p.disabled?"#cbd5e1":"#374151"}}>{p.label}</button>;
}
export function ConfirmModal(p) {
  if(!p.data) return null;
  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div style={{background:"#fff",borderRadius:14,padding:24,width:"100%",maxWidth:360,boxShadow:"0 20px 60px rgba(0,0,0,0.2)"}}>
        <p style={{fontSize:15,fontWeight:600,color:"#0f172a",margin:"0 0 20px",textAlign:"center"}}>{p.data.msg}</p>
        <div style={{display:"flex",gap:10}}>
          <button onClick={p.onCancel} style={{flex:1,padding:"10px 0",borderRadius:9,border:"1px solid #e2e8f0",background:"#fff",color:"#64748b",fontWeight:600,fontSize:13,cursor:"pointer"}}>Cancelar</button>
          <button onClick={p.onConfirm} style={{flex:1,padding:"10px 0",borderRadius:9,border:"none",background:"#dc2626",color:"#fff",fontWeight:700,fontSize:13,cursor:"pointer"}}>Eliminar</button>
        </div>
      </div>
    </div>
  );
}
